import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../lib/api";
import ExportCsvButton from "../components/ExportCsvButton";

const STATUS_BADGE = {
  active: "badge-active", verified: "badge-success", pending: "badge-pending", suspended: "badge-suspended",
};

export default function Merchants() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    api.get("/merchants", { params: filter ? { status: filter } : {} })
       .then((r) => {
         const list = Array.isArray(r.data) ? r.data : (r.data?.merchants || []);
         setItems(list);
       });
  }, [filter]);

  return (
    <div className="p-8 space-y-6" data-testid="merchants-page">
      <header className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#c15337]">{t("admin_pages.merchants_section")}</div>
          <h1 className="font-heading text-3xl font-bold mt-1 text-[#114232]">{t("admin_pages.merchants_title")}</h1>
        </div>
        <ExportCsvButton
          path="/admin/exports/merchants.csv"
          filename="merchants"
          params={filter ? { status: filter } : {}}
          testid="export-merchants-csv"
        />
      </header>

      <div className="flex items-center gap-2 text-sm">
        {["", "active", "verified", "pending", "suspended"].map((s) => (
          <button
            key={s || "all"}
            onClick={() => setFilter(s)}
            data-testid={`filter-${s || "all"}`}
            className={`px-3 py-1.5 rounded-sm border ${
              filter === s ? "bg-primary text-primary-foreground border-primary"
                           : "border-border hover:bg-stone-50"
            }`}
          >
            {s ? s.charAt(0).toUpperCase() + s.slice(1) : "All"}
          </button>
        ))}
      </div>

      <div className="bg-white border border-border rounded-md overflow-x-auto">
        <table className="w-full text-sm" data-testid="merchants-table">
          <thead className="text-xs uppercase tracking-wider text-stone-500">
            <tr>
              <th className="text-left font-medium py-3 px-5">Business</th>
              <th className="text-left font-medium py-3 px-5">Owner</th>
              <th className="text-left font-medium py-3 px-5">Phone</th>
              <th className="text-left font-medium py-3 px-5">KYC / KYB</th>
              <th className="text-left font-medium py-3 px-5">Risk</th>
              <th className="text-left font-medium py-3 px-5">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((m) => (
              <tr key={m.id} className="border-t border-border table-row-hover" data-testid={`merchant-row-${m.id}`}>
                <td className="py-3 px-5">
                  <Link to={`/merchants/${m.id}`} className="hover:text-primary transition-colors">
                    <div className="font-medium text-stone-900">{m.business_name}</div>
                    <div className="text-xs text-muted-foreground font-mono">{m.id.slice(0, 8)}…</div>
                  </Link>
                </td>
                <td className="py-3 px-5">{m.owner_name}</td>
                <td className="py-3 px-5 font-mono text-xs">{m.phone}</td>
                <td className="py-3 px-5 text-xs">
                  <div>KYC: <span className="font-medium">{m.kyc_status}</span></div>
                  <div>KYB: <span className="font-medium">{m.kyb_status}</span></div>
                </td>
                <td className="py-3 px-5 font-mono">{m.risk_score}</td>
                <td className="py-3 px-5">
                  <span className={`badge-status ${STATUS_BADGE[m.status] || "badge-pending"}`}>
                    {m.status}
                  </span>
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={6} className="py-10 text-center text-muted-foreground">No merchants found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
